export type CookieConsentSource = 'ok_click' | 'auto_close' | 'scroll';

export interface CookieConsentRequestBody {
  source: CookieConsentSource;
  acceptedAt?: string;
  pageUrl?: string;
  guestId?: string;
}

export interface CookieConsentResponse {
  data: {
    recorded: boolean;
  };
}

export const COOKIE_CONSENT_STORAGE_KEY = 'cookie_consent_ack';
export const COOKIE_CONSENT_API_PATH = '/client/consent/cookies/';
